import * as React from "react";
import {authorize, IWithRouterProps, withRouter} from "@athena-portal/components";
import FalconHeader from "../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../utils/PluginTemplates";
import {ButtonLink} from "../../../components/navigation/ButtonLink";
import {Policy, productHelper} from "@ferry/journey-services";
import {FalconNavigatorHeader, Footer} from "@ferry/portal-core";
import {lazyInject} from "@athena-portal/core";
import {Types} from "../../../Types";
import type {ICustomerPortalService} from "../../../services/ICustomerPortalService";

interface IParams {
    policyNumber: string;
    [key: string]: string | undefined
}

interface IState {
    link: string,
    annualMotorChecked: boolean,
    policies?: Policy[];
    currentPolicy?: Policy
}

@authorize
export class PickClaimKindPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps<IParams>) {
        super(props);
        this.state = {
            link: "",
            annualMotorChecked: false,
            policies: [],
            currentPolicy: undefined
        };
    }

    public componentDidMount(): void {
        window.scrollTo(0, 0);
        this.pluginTemplates.setPageTitle("Your claims");

        const policyNumber: string = this.props.params.policyNumber;

        this.customerPortalService.getPolicy(policyNumber).subscribe((currentPolicy) => {
            this.setState({
                currentPolicy
            });
        });

        this.customerPortalService.getPolicies().subscribe((policies: Policy[]) => {
            this.setState({
                policies
            });
        });
    }

    public render() {
        return (
            <React.Fragment>

                <FalconHeader/>
                <div className="plugin claims">
                    <FalconNavigatorHeader back="/dashboard" title="Make a claim"/>
                    <div>
                        <div className="page-contents">
                            {this.renderRadios()}
                        </div>
                        <div className="px-md-0 ml-md-19 button-container">
                            <ButtonLink to={this.state.link} primary={true} routeState={{prevPath: location.pathname, product: this.state.currentPolicy?.products[0]}}
                                        disabled={this.state.link === ""}> Next </ButtonLink>
                        </div>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, "/dashboard")}
                </div>
                <Footer/>

            </React.Fragment>
        );
    }

    private readonly renderRadios = () => {
        if (this.state.policies) {
            const annualMotorPolicyPresent = (productHelper.includesWolfMotorProduct(this.state.policies)) ||
                productHelper.includesNonExpiredWolfMotorPolicies(this.state.policies);

            return (
                <div className="panel">
                    <p className="font-weight-semi-bold ml-1 mt-3 pr-4">Please choose what type of claim you want to make?</p>
                    {annualMotorPolicyPresent && <div className="custom-control mt-2 ml-2 mb-3">
                        <input
                            className={"custom-radiobutton cursor-pointer"}
                            type="radio"
                            name="product-annual-motor"
                            id="product-annual-motor"
                            value="annual"
                            checked={this.state.annualMotorChecked}
                            onChange={this.handleOnChangeEvent}
                        />
                        <label id={'claim-type-label'} className="checkbox-label label-bg-transparent"
                               htmlFor="product-annual-motor">
                            Car (annual cover)
                        </label>
                    </div>}
                </div>
            );
        } else {
            return (<></>);
        }

    };

    private handleOnChangeEvent = (event: any): void => {
        if (event.target.value === "annual") {
            const policyNumber = this.state.policies ? this.state.policies[0].policyNumber : "";
            this.setState({
                link: `/dashboard/pickMotorClaimKind/${policyNumber}`,
                annualMotorChecked: true
            });
        }
    };
}

export const PickClaimKindPage = withRouter(PickClaimKindPagePlain)
